import React from 'react';
import { RhColumns, RHTextField } from '../../../../../../dum';
import { IAccount } from '../account-form';
import { FIELD_LABELS, shortLabel } from '../../../../../../../helpers';

const ARRAY_NAME: keyof IAccount = 'account_contacts';

const defaultValue: IAccount['account_contacts'][number] = {
    first_name: '',
    last_name: '',
    cellphone: '',
    email: '',
};

const FIRST_NAME_FIELD_NAME: keyof IAccount['account_contacts'][number] =
    'first_name';
const LAST_NAME_FIELD_NAME: keyof IAccount['account_contacts'][number] =
    'last_name';
const CELLPHONE_FIELD_NAME: keyof IAccount['account_contacts'][number] =
    'cellphone';
const EMAIL_FIELD_NAME: keyof IAccount['account_contacts'][number] = 'email';

export function AccountContactsColumns() {
    return (
        <RhColumns
            title={'Contactos'}
            name={ARRAY_NAME}
            defaultValue={defaultValue}
            items={[
                {
                    getField: (index) => {
                        return (
                            <RHTextField
                                name={`${ARRAY_NAME}.${index}.${FIRST_NAME_FIELD_NAME}`}
                                label={shortLabel(FIELD_LABELS.first_name)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    getField: (index) => {
                        return (
                            <RHTextField
                                name={`${ARRAY_NAME}.${index}.${LAST_NAME_FIELD_NAME}`}
                                label={shortLabel(FIELD_LABELS.last_name)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    cellGrow: 2,
                    getField: (index) => {
                        return (
                            <RHTextField
                                name={`${ARRAY_NAME}.${index}.${CELLPHONE_FIELD_NAME}`}
                                label={shortLabel(FIELD_LABELS.cellphone)}
                                disableGutters
                            />
                        );
                    },
                },
                {
                    cellGrow: 3,
                    getField: (index) => {
                        return (
                            <RHTextField
                                name={`${ARRAY_NAME}.${index}.${EMAIL_FIELD_NAME}`}
                                label={shortLabel(FIELD_LABELS.email)}
                                disableGutters
                            />
                        );
                    },
                },
            ]}
        />
    );
}
